// removed by extract-text-webpack-plugin
module.exports = {"list_inscriptions":"_3X5xP8tn8PdS6wjO3RAwFo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/MyInscriptions/style.css
// module id = 272
// module chunks = 42